document.addEventListener("DOMContentLoaded", function () {
  let fields = document.getElementsByClassName("gfield");
  fields = Array.from(fields);
  let dropdown = document.querySelector(".contact-dropdown");
  const label = document.querySelector(".phone-field");

  if (label) {
    const phoneLabel = label.querySelector("label");
    phoneLabel.innerHTML = phoneLabel.innerText;
  }

  const FOCUS_CLASS = "focus";

  if (dropdown) {
    dropdown.addEventListener("focusin", function () {
      dropdown.classList.add(FOCUS_CLASS);
    });
    dropdown.addEventListener("focusout", function () {
      dropdown.classList.remove(FOCUS_CLASS);
    });
  }

  if (fields.length) {
    fields.forEach((field, index) => {
      const input = field.querySelector("input");
      const textarea = field.querySelector("textarea");

      if (input) {
        if (input.value.length != 0) {
          field.classList.add(FOCUS_CLASS);
        }
        field.addEventListener("focusout", function () {
          if (input.value.length === 0) {
            this.classList.remove(FOCUS_CLASS);
          }
        });

        field.addEventListener("focusin", function () {
          this.classList.add(FOCUS_CLASS);
        });

        input.addEventListener("blur", function () {
          field.classList.add(FOCUS_CLASS);
        });

        input.addEventListener("input", function () {
          field.classList.add(FOCUS_CLASS);
        });
      } else if (textarea) {
        if (textarea.value.length != 0) {
          field.classList.add(FOCUS_CLASS);
        }
        field.addEventListener("focusout", function () {
          if (textarea.value.length === 0) {
            this.classList.remove(FOCUS_CLASS);
          }
        });

        field.addEventListener("focusin", function () {
          this.classList.add(FOCUS_CLASS);
        });
      }
    });
  }
});

// portal forms from registration magic plugin
document.addEventListener("DOMContentLoaded", function () {
  const addClass = (field) => {
    if (field) {
      field.forEach((row) => {
        row.querySelector("input")?.addEventListener("change", (e) => {
          if (e.target.value) {
            row.classList.add("hasValue");
          } else {
            row.classList.remove("hasValue");
          }
        });
      });
    }
  };

  const rmrow = document.querySelectorAll(".rmrow");
  addClass(rmrow);

  // portal forms from gravity forms plugin plugin
  const loginContainer = document.querySelector(".portal-login__form--wrapper");
  if (loginContainer) {
    const gfield = document.querySelectorAll(".gfield");
    addClass(gfield);
  }
});
